<template>
  <div class="theme-color-wrapper p-2 bans-page">
    <div class="row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-sm-0 mb-2">Social Bans</h2>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-3">
        <section>
          <label>Visitor First Name</label>
          <b-form-input
            v-model="filters.firstname" cy="firstname"
            placeholder="enter firstname"
            @keypress.enter="getBans"
          />
        </section>
      </div>
      <div class="col-3">
        <section>
          <label>Visitor Last Name</label>
          <b-form-input
            v-model="filters.lastname" cy="lastname"
            placeholder="enter lastname"
            @keypress.enter="getBans"
          />
        </section>
      </div>
      <div class="col-3">
        <section>
          <label>Visitor Email</label>
          <b-form-input
            v-model="filters.email" cy="email"
            placeholder="enter email"
            @keypress.enter="getBans"
          />
        </section>
      </div>
      <div class="col-3" />
      <section class="col-3 mt-1">
        <label>Before Date</label>
        <b-form-datepicker
          v-model="filters.before" today-button
          cy="before" reset-button
          close-button
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          @input="getBans"
        />
      </section>

      <section class="col-3 mt-1">
        <label>After Date</label>
        <b-form-datepicker
          v-model="filters.after" today-button
          cy="after" reset-button
          close-button
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          @input="getBans"
        />
      </section>

      <section class="col-3 mt-1">
        <label>Sort</label>
        <b-form-select v-model="filters.sort" cy="sort" @change="getBans">
          <b-form-select-option v-for="sort in sorts" :key="sort.value" :value="sort.value">{{ sort.text }}</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-3 mt-1 d-flex flex-column justify-content-end align-items-end">
        <b-btn variant="primary" @click="getBans">Search</b-btn>
      </section>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div>
          <div v-if="bans && bans.length > 0" class="bans-table">
            <b-table
              hover
              :fields="headers"
              :items="bans"
              :current-page="currentPage"
              :per-page="null"
              :responsive="true" cy="bans-table"
            >
              <template slot="actions" slot-scope="row">
                <b-btn variant="primary" class="btn btn-sm text-white"
                       @click="showBanModal('modal-view-ban', row.item)"
                >View
                </b-btn>
              </template>

              <template #cell(actions)="data">
                <b-btn variant="link" @click="showBanModal('modal-view-ban', data.item)">View
                </b-btn>
              </template>
            </b-table>
          </div>
          <b-row v-if="bans && bans.length > 0">
            <b-col md="6" class="my-1">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="filters.limit" class="my-0"
                            @input="getBans"
              />
            </b-col>
          </b-row>
          <div v-if="!bans || bans.length === 0">
            <p>No bans to show</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-view-ban" ref="modal-view-ban" size="md" hide-footer hide-header :click-to-close="false">
      <view-social-ban v-if="selectedBan" :ban="selectedBan" @close="closeModals()" />
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import HelperService from '@/services/HelperService';
import SocialBansService from "@/services/SocialBansService";
import ViewSocialBan from "@/views/socialBans/ViewSocialBan.vue";

export default {
  name: 'BanSearch',
  components: {
    ViewSocialBan,
  },
  props: {},
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      bans: [],
      filters: {
        firstname: '',
        lastname: '',
        email: '',
        before: '',
        after: '',
        skip: 10,
        limit: 10,
        sort: 'start_date',
      },
      currentPage: 1,
      totalRows: 10,
      headers: [
        { label: 'Visitor', key: 'name' },
        { label: 'Start Date', key: 'start_date' },
        { label: 'End Date', key: 'end_date' },
        { label: 'Banned By', key: 'banned_by' },
        { label: '', key: 'actions' },
      ],
      selectedBan: null,
      sorts: [
        { text: 'Upcoming Start', value: 'start_date' }, { text: 'Furthest Start', value: '-start_date' },
        { text: 'Upcoming End', value: 'end_date' }, { text: 'Furthest end', value: '-end_date' },
      ],
    };
  },
  mounted() {
    this.getBans();
  },
  methods: {
    getBans() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;

      SocialBansService.getSocialBansPaginated(this.filters).then(res => {
        this.bans = this.formatBans(res.data.data);
        this.totalRows = res.data.count;
        this.closeModals();
      }).catch(err => {
        console.log('Error getting bans', err);
        this.$toasted.error('Error getting bans. Please refresh the page');
      }).finally(() => {
        this.loading = false;
      });
    },
    formatBans(bans) {
      return bans.map(item => {
        const name = item.visitor ? `${item.visitor.firstname} ${item.visitor.lastname}` : '-';
        const date = { ...item, name };
        date.start_date = moment(date.start_date).format('DD/MM/YYYY');
        date.end_date = moment(date.end_date).format('DD/MM/YYYY');
        return date;
      });
    },
    backRoute() {
      this.$router.go(-1);
    },
    closeModals() {
      this.$refs['modal-view-ban'].hide();
    },
    showBanModal(modalName, ban) {
      this.selectedBan = ban;
      this.$refs[modalName].show();
    },
  },
};
</script>
